import React from 'react';
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {hashHistory} from "react-router";

import TextInput from "../../Generic/textInput";
import CheckBox from "../../PageLayout/CheckBox";
import {updateWizardList} from "../wizardActions";
import {wizardItemInterface} from "./wizardItemInterface";
import WizardItemActionButtons from "./WizardItemActionButtons";
import WizardItemThumbnail from "./WizardItemThumbnail";


const WizardItem = (props) => {

  const {wizardItem, updateWizardList, intl} = props;

  const updateWizardItem = (property, newValue) => {
    wizardItem[property] = newValue;
    updateWizardList(wizardItem);
  }

  const wizardItemEditClick = () => {
    hashHistory.push("/wizard/" + wizardItem.id);
  }

  return (
    <div className="wizard-item">
      <div className="wizard-item__box">
        <WizardItemThumbnail wizardItem={wizardItem}/>
        <div className="wizard-item__box-checkbox">
          <CheckBox checked={wizardItem.selected}
                    onChecked={(selected) => updateWizardItem("selected", !selected)}
                    text=""/>
        </div>
        <div className="wizard-item__box-edit">
          <button className="ui-icon--rounded ui-icon-edit ui-icon-edit--blue" onClick={wizardItemEditClick}/>
        </div>
      </div>
      <div className="wizard-item__content">
        <div className="wizard-item__content-body">
          <div className="wizard-item__description">
            <div className="wizard-item__content-name">
              <TextInput className={"ui-input ui-input--gray4 text-left"}
                         placeholder={intl.formatMessage({id: "wizard.item.name"})}
                         onChange={(value) => updateWizardItem("name", value)}
                         value={wizardItem.name}/>
            </div>
            <textarea className={"ui-input ui-input--gray4 text-left"}
                      placeholder={intl.formatMessage({id: "wizard.item.description"})}
                      onChange={(event) => updateWizardItem("description", event.target.value)}
                      value={wizardItem.description}/>
          </div>
          <WizardItemActionButtons wizardItem={wizardItem}/>
        </div>
      </div>
    </div>
  )
};

WizardItem.propTypes = {
  wizardItem: PropTypes.shape(wizardItemInterface)
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  updateWizardList,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardItem)
);
